import createIcon from '../../createIcon';

/**
 * @component @name ZoomInMap
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA5VjNIN1Y1LjU5TDMuOTEgMi41TDIuNSAzLjkxTDUuNTkgN0gzVjlIOVpNMjEgOVY3SDE4LjQxTDIxLjUgMy45MUwyMC4wOSAyLjVMMTcgNS41OVYzSDE1VjlIMjFaTTMgMTVWMTdINS41OUwyLjUgMjAuMDlMMy45MSAyMS41TDcgMTguNDFWMjFIOVYxNUgzWk0xNSAxNVYyMUgxN1YxOC40MUwyMC4wOSAyMS41TDIxLjUgMjAuMDlMMTguNDEgMTdIMjFWMTVIMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ZoomInMap = createIcon('ZoomInMap', [
  [
    'path',
    {
      d: 'M9 9V3H7V5.59L3.91 2.5L2.5 3.91L5.59 7H3V9H9ZM21 9V7H18.41L21.5 3.91L20.09 2.5L17 5.59V3H15V9H21ZM3 15V17H5.59L2.5 20.09L3.91 21.5L7 18.41V21H9V15H3ZM15 15V21H17V18.41L20.09 21.5L21.5 20.09L18.41 17H21V15H15Z',
      key: 'o8aytl',
    },
  ],
]);

export default ZoomInMap;
